import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import { useNavigate } from 'react-router-dom';
import { hapticsImpactLight } from '../../../../common/haptic';

const ScrollingContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: transparent;
  overflow: hidden;
  z-index: 1;
  padding: 0;
  @media ${PHONE_MEDIA_QUERY} {
    width: 100vw;
  }
`;

const InnerScroll = styled.div`
  overflow: hidden;
  white-space: nowrap;
  animation: ${(props) => (props.reverse ? 'scrollTextReverse' : 'scrollText')}
    40s infinite linear;
  margin: 0;
  font-size: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: fit-content;

  @keyframes scrollText {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-50%);
    }
  }

  @keyframes scrollTextReverse {
    from {
      transform: translateX(-50%);
    }
    to {
      transform: translateX(0%);
    }
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InnerContainer = styled.div`
  max-width: calc(1440px + 48px);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 48px;
  padding-left: 24px;
  padding-right: 24px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 32px;
    max-width: unset;
    padding-left: 16px;
    padding-right: 16px;
    flex-direction: ${({ avoidDirectionChange }) =>
      avoidDirectionChange ? 'row' : 'column'};
  }
`;

const RowComponent = ({
  children,
  style = {},
  innerContainerStyle = {},
  avoidDirectionChange = false,
}) => {
  return (
    <Row style={style}>
      <InnerContainer
        style={innerContainerStyle}
        avoidDirectionChange={avoidDirectionChange}
      >
        {children}
      </InnerContainer>
    </Row>
  );
};

const HorizontalScroll = ({ icons, reverse = false }) => {
  return (
    <ScrollingContainer>
      <InnerScroll reverse={reverse}>
        {icons.map((icon, index) => (
          <div key={`first-${index}`}>{icon}</div>
        ))}
        {icons.map((icon, index) => (
          <div key={`second-${index}`}>{icon}</div>
        ))}
        {icons.map((icon, index) => (
          <div key={`third-${index}`}>{icon}</div>
        ))}
        {icons.map((icon, index) => (
          <div key={`fourth-${index}`}>{icon}</div>
        ))}
      </InnerScroll>
    </ScrollingContainer>
  );
};

const IconContainer = styled.div`
  width: 300px;
  height: 196px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  @media ${PHONE_MEDIA_QUERY} {
    width: 250px;
    height: 168px;
  }
`;

const Icon = styled.img`
  cursor: pointer;
  border-radius: 5%;
  object-fit: cover;
  width: 100%;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
`;

const Icons = [
  {
    image: '/landing-v2/cards/BONK.webp',
    address: 'DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263',
  },
  {
    image: '/landing-v2/cards/SOL.webp',
    address: 'So11111111111111111111111111111111111111112',
  },
  {
    image: '/landing-v2/cards/USDC.webp',
    address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  },
  {
    image: '/landing-v2/cards/BTC.webp',
    address: '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh',
  },
];

const Icons2 = [
  {
    image: '/landing-v2/cards/APPLE.webp',
    address: 'XsbEhLAtcf6HdfpFZ5xEMdqW8nfAvcsP5bdudRLJzJp',
  },
  {
    image: '/landing-v2/cards/OPENAI.webp',
    address: 'PreYKD2kJ5xGgoZ644VPfbEN7sW8bWCUREHr5S3ebV9',
  },
  {
    image: '/landing-v2/cards/SPACEX.webp',
    address: 'Preb5VKsmKgMGhMKUhDpe7A2AhMDmrZtMMZmvFEhLbU',
  },
  {
    image: '/landing-v2/cards/TESLA.webp',
    address: 'XsDoVfqeBukxuZHWhdvWHBhgEHjGNst4MLodqsJHzoB',
  },
];

const Container = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  position: relative;
`;

const DissapearSoftener = styled.div`
  pointer-events: none;
  height: 100%;
  position: absolute;
  ${(props) => (props.reverse ? 'right: 0px;' : 'left: 0px;')};
  width: 150px;
  z-index: 3;
  background: ${(props) =>
    props.reverse
      ? `linear-gradient(90deg, rgba(${props.theme.background.rgb}, 0) 0%, rgba(${props.theme.background.rgb}, 1) 80%)`
      : `linear-gradient(90deg, rgba(${props.theme.background.rgb}, 1) 20%, rgba(${props.theme.background.rgb}, 0) 100%)`};
`;

const GiftCardsScroll = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <DissapearSoftener reverse={false} />
      <DissapearSoftener reverse={true} />
      <RowComponent>
        <HorizontalScroll
          icons={Icons.map((icon) => (
            <IconContainer
              onClick={() => {
                hapticsImpactLight();
                navigate(`/app/tokens/${icon.address}?back=/`);
              }}
            >
              <Icon src={icon.image} />
            </IconContainer>
          ))}
        />
      </RowComponent>
      <RowComponent>
        <HorizontalScroll
          icons={Icons2.map((icon) => (
            <IconContainer
              onClick={() => {
                hapticsImpactLight();
                navigate(`/app/tokens/${icon.address}?back=/`);
              }}
            >
              <Icon src={icon.image} />
            </IconContainer>
          ))}
          reverse={true}
        />
      </RowComponent>
    </Container>
  );
};

export default GiftCardsScroll;
